import { render } from "./SuspectsCompleted.vue?vue&type=template&id=7184981b"
import script from "./SuspectsCompleted.vue?vue&type=script&lang=js"
export * from "./SuspectsCompleted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__